"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductImage = void 0;

var _styles = require("./styles");

var _reactImageFallback = _interopRequireDefault(require("react-image-fallback"));

var _defaultProductImage = _interopRequireDefault(require("../../../assets/images/defaultImages/defaultProductImage.png"));

var _jsxRuntime = require("react/jsx-runtime");

var ProductImage = function ProductImage(_ref) {
  var img = _ref.img,
      imageType = _ref.imageType,
      altText = _ref.altText,
      onClick = _ref.onClick;
  // Expresión regular para validar que los últimos tres caracteres sean ".mp4"
  var regex = /\.mp4$/;

  if (regex.test(img)) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
      className: imageType,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("video", {
        controls: true,
        width: "100%",
        height: "auto",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
          src: img,
          type: "video/mp4"
        })
      })
    });
  } else {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
      className: imageType,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactImageFallback.default, {
        src: img,
        fallbackImage: _defaultProductImage.default,
        alt: altText,
        onClick: onClick
      })
    });
  }
};

exports.ProductImage = ProductImage;